import { defineRule } from 'vee-validate'
import * as rules from '@vee-validate/rules'

export default defineNuxtPlugin((nuxtApp) => {
  Object.keys(rules)
    .filter((rule) => typeof rules[rule] === 'function' && rule !== 'default')
    .forEach((rule) => defineRule(rule, rules[rule]))
})
